'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function SessionStorageHandler() {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Store swd_vkn if present
      const vknParam = searchParams.get('swd_vkn');
      if (vknParam) {
        sessionStorage?.setItem('swd_vkn', vknParam);
      }

      // Store t_mc if present
      const tMcParam = searchParams.get('t_mc');
      if (tMcParam) {
        sessionStorage?.setItem('t_mc', tMcParam);
      }

      // Store swd_campaign from supported query params: swd_campaign, utm_campaign, campaign
      let campaignParam: string | null = null;
      if (searchParams?.has('swd_campaign')) {
        campaignParam = searchParams.get('swd_campaign');
      } else if (searchParams?.has('utm_campaign')) {
        campaignParam = searchParams.get('utm_campaign');
      } else if (searchParams?.has('campaign')) {
        campaignParam = searchParams.get('campaign');
      }
      if (campaignParam !== null) {
        sessionStorage?.setItem('swd_campaign', campaignParam ?? '');
      }
    }
  }, [searchParams]);

  return null; // No UI needed
}
